import { Button } from "@/components/common/Button";
import Modal from "@/components/common/Modal";
import { useAirdropValueStore } from "@/modules/airdrop/store/value";
import { useUserStore } from "@/modules/auth/store/user";
import { formatNumber } from "@/modules/auth/utils/format";
import { constants } from "@/modules/calculations/consts";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

interface Props {
  amount: number;
  onClose: () => void;
}

const SuccessfulClaimedAirdrop = ({ amount, onClose }: Props) => {
  const { t } = useTranslation();
  const { setAirdrop } = useUserStore();

  const { currentToken, net } = useAirdropValueStore();

  const navigate = useNavigate();

  const goToMain = async () => {
    await navigate("/");
  };

  const closeModalRedirect = async () => {
    onClose();
    await setAirdrop();
    await goToMain();
  };

  return (
    <Modal title={t("airdrop-page.claimed")} onClose={closeModalRedirect}>
      <div className="w-full flex flex-col items-center p-8 gap-6">
        <img src="/images/ok.png" alt="" className="w-32 h-32" />
        <div className="flex flex-col items-center gap-1 text-center">
          <p className="text-[1.25rem] leading-[1.5625rem] font-semibold text-text">
            {t("airdrop-page.airdrops_claimed", {
              amount: formatNumber(amount, {
                precision:
                  currentToken === "token" ||
                  currentToken === "" ||
                  net === "base"
                    ? constants.TOKEN_DECIMALS
                    : constants.TON_DECIMALS,
              }),
              token:
                currentToken === "token" ||
                currentToken === "" ||
                net === "base"
                  ? "BTN"
                  : "TON",
            })}
          </p>
          <p className="text-[1.0625rem] leading-[1.375rem] text-hint -tracking-[0.025rem]">
            {t("airdrop-page.tokens_successfully_credited")}
          </p>
        </div>

        <Button
          onClick={closeModalRedirect}
          text={t("referral-page.to_main")}
          size="large"
          className="w-full"
        />
      </div>
    </Modal>
  );
};

export default SuccessfulClaimedAirdrop;
